import { type ChakraStyledOptions, Box } from "@chakra-ui/react";
import { sidebarWidth } from "components/sidebar";
import React, { type ReactNode } from "react";
import { textStyles } from "theme/text-styles";
import { CodeTheme } from "ui/code";
import { articleContainerGap } from "./article-container";

const styles: ChakraStyledOptions = {
  caption: {
    ...textStyles.caption2,
    lineHeight: "none",
    mt: -4,
    display: "block",
    maxW: "80%",
    mx: "auto",
    p: {
      fontSize: "inherit",
    },
  },
  figure: {
    mb: 16,
    p: {
      fontSize: "3xl",
      mb: 8,
      lineHeight: 1.4,
    },
    figcaption: {
      display: "flex",
      alignItems: "center",
      cite: {
        fontStyle: "normal",
        fontSize: "md",
        h1: {
          fontWeight: "semibold",
        },
      },
      img: {
        height: "104px",
        mr: 8,
      },
    },
  },
};

export function Article({ children }: { children: ReactNode }) {
  return (
    <>
      <Box
        fontFamily="body"
        fontSize="lg"
        flex={1}
        lineHeight="1.7rem"
        maxW={{ base: "100%", lg: `calc(100% - (${sidebarWidth} + var(--chakra-space-${articleContainerGap})))` }}
        sx={styles}
      >
        {children}
      </Box>
      <CodeTheme />
    </>
  );
}
